import QrScanner from "qr-scanner";

const ticketQrCodePattern = /^https?:\/\/[^/]+\/pdfqr\/(\d{8,})\/(.+)?(\?.*)?$/i;

const qrCodeOrderIdExtractor = (result: QrScanner.ScanResult): string | undefined =>
  result.data.match(ticketQrCodePattern)?.[1];

export default qrCodeOrderIdExtractor;
